import { Enumify } from "enumify-ts";
class DMSBillingType extends Enumify() {
    description;
    static PREPAID_CREDIT = new DMSBillingType("Prepaid Credit");
    static CONTRACT = new DMSBillingType("Contract");
    static _ = DMSBillingType._closeEnum();
    constructor(description) {
        super();
        this.description = description;
    }
    static selectOptionsArray() {
        return DMSBillingType.values.map(it => {
            return {
                label: it.description,
                value: it.key
            };
        });
    }
}
export default DMSBillingType;
